import styled, { keyframes, css } from "styled-components";
// import tinycolor from "tinycolor2";

const blink = (config) => keyframes`
   8% {
      opacity: 0;
    }
    16% {
      opacity: 100;
    }
    25% {
      opacity: 0;
    }
    33% {
      opacity: 100;
    }
  }
`;

const repetitionLoop = (config) => {
  const duration = config.config.mobile.buttonAnimationRepetitionEnable
    ? "infinite"
    : 1;
  return duration;
};

export const BlinkButton = styled.button`
  animation: ${(config) =>
    config.config.buttonAnimation
      ? css`
          ${blink(config)} ${4}s ${config.config.mobile
            .buttonAnimationInitTime}s ${repetitionLoop(config)}
        `
      : null};
`;

// export const BlinkButton = styled.button`
//   cursor: pointer;
//   background-color: ${(config) =>
//     tinycolor(config.config.mobile.buttonBackgroundColor)};
//   border-color: ${(config) =>
//     tinycolor(config.config.mobile.buttonBorderColor)};
//   margin-right: ${(config) => config.config.mobile.buttonMarginRight}px;
//   margin-left: ${(config) => config.config.mobile.buttonMarginLeft}px;
//   margin-bottom: ${(config) => config.config.mobile.buttonMarginBottom}px;
//   animation: ${(config) =>
//     config.config.buttonAnimation
//       ? css`
//           ${blink(config)} ${4}s ${config.config.mobile.buttonAnimationInitTime}s ${1}
//         `
//       : null};
// `;
